import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import broadcastIcon from "Assets/newicons/notify/broadcast/outline/broadcast-outline-16px.svg";
import timeIcon from "Assets/newicons/notify/hourglass/outline/hourglass-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import checkall from "Assets/Svg/check-all.svg";
import eyeball from "Assets/Svg/eyeballs.svg";
import raisinghands from "Assets/Svg/raising-hands.svg";
import sleepface from "Assets/Svg/sleep-face.svg";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { withSnackbar } from "notistack";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import { getFormattedDate } from "../../../../../Utils";
import { GetNumberOfEmp } from "../Functions";

const styles = () => ({
  TableRow: {
    borderRadius: 4,
  },
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
});

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMore: true,
      moreDetails: false,
      moreDeatail_anchorEl: null,
      showform: null,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.takeAction = this.takeAction.bind(this);
  }

  componentDidMount() {
    const { totalcount, forms } = this.props;
    this.setState({
      hasMore: forms.length >= totalcount ? false : true,
    });
  }

  handleScroll() {
    const { totalcount, forms } = this.props;
    if (forms.length >= totalcount) {
      this.setState({ hasMore: false });
      return;
    }
    setTimeout(() => {
      this.props.getForms();
    }, 200);
  }

  takeAction(e, form, id) {
    e.stopPropagation();
    const data = {
      actionid: id,
      empreviewformid: form.empreviewformid,
      empreviewdetailid: form.empreviewdetailid,
    };
    this.setState(
      {
        showform: null,
        moreDetails: false,
        moreDeatail_anchorEl: null,
      },
      () => {
        this.props.takeAction(form, data);
      },
    );
  }

  render() {
    const { forms, statusid } = this.props;
    const { showform } = this.state;
    const { classes } = this.props;
    return (
      <Grid item md={12} sm={12}>
        <div>
          <InfiniteScroll
            dataLength={forms.length}
            next={this.handleScroll}
            hasMore={this.state.hasMore}
            // more={this.state.hasMore}
            loader={
              <p className="loading" style={{ textAlign: "center" }}>
                Loading
              </p>
            }
            height={"100vh"}
            endMessage={
              <p style={{ textAlign: "center" }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
            className="thin-scroll width100"
            style={{ overflowY: "auto", overflowX: "hidden", height: "70vh" }}
          >
            {/* <Grid container spacing={2}>
              {forms &&
                forms.map((form) => (
                  <div>
                    <Grid item md={4} sm={12}>
                      <div
                        className="rounded-rectangle-div"
                        style={{ height: 124 }}
                        onClick={() => this.props.openForm(form)}
                      >
                        <div className="floatleft">
                          <span className="margin-right-8">
                            <ProfilePicture
                              src={getFormattedImageLink(form.imagepath)}
                              height="24"
                            />
                          </span>
                          <span className="small-dark-secondary t-bold">
                            {form.fullname}
                          </span>
                        </div>
                        {form.actions &&
                          ((statusid == 5 && form.actions.isreleased) ||
                            (statusid != 3 && form.actions.iscancle) ||
                            (statusid != 4 && form.actions.isonhold)) && (
                            <div
                              className="floatright cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  showform: form,
                                  moreDetails: true,
                                  moreDeatail_anchorEl: e.currentTarget,
                                });
                              }}
                            >
                              <img src={kebabIcon}></img>
                            </div>
                          )}
                        <div className="clear-float"></div>
                        <Tooltip
                          key="key"
                          title={form.formtitle}
                          classes={{
                            tooltip: classes.customWidth,
                          }}
                        >
                          <p className="floatleft cursour-pointer ellipsis width60 extra-small-dark-secondary margin-bottom-8 margin-top-8">
                            {form.formtitle}
                          </p>
                        </Tooltip>
                        {form.reviewperiodtypeid && (
                          <div className="floatright margin-top-8">
                            <span className="margin-right-8 floatleft">
                              <LabelIcon label={""} img={calendarIcon} />
                            </span>
                            <span className="small-dark-secondary">
                              {form.reviewperiodtypeid == 1
                                ? shortmonths[form.openid - 1].displayname
                                : form.reviewperiodtypeid == 2
                                ? "Q"
                                : form.reviewperiodtypeid == 3
                                ? "H"
                                : ""}
                              {form.reviewperiodtypeid != 4
                                ? form.reviewperiodtypeid != 1
                                  ? form.openid
                                  : ""
                                : ""}{" "}
                              {selectedcycle && selectedcycle.year}
                            </span>
                          </div>
                        )}
                        <div className="clear-float"></div>

                        <div className="clear-float"></div>
                        <Grid container>
                          <div className="avtar-thumb-wrapper-small">
                            {form.participant && form.participant.length > 0 ? (
                              form.participant.map((emp) => (
                                <Tooltip
                                  key="key"
                                  title={emp.employeename || emp.fullname}
                                  placement="bottom"
                                  classes={{
                                    tooltip: classes.customWidth,
                                  }}
                                >
                                  <div
                                    className={
                                      GetNumberOfEmp(
                                        form.participant[0].fullcount,
                                      ) > 0
                                        ? "avtar-thumb-blur"
                                        : "avtar-thumb"
                                    }
                                  >
                                    <Link
                                      to={`./profile/${emp.employeeid}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <div className="avatar-wrapper-small">
                                        {!emp.imagepath ||
                                        emp.imagepath == null ? (
                                          <img
                                            src={DefaultProfileImage}
                                            height="40"
                                            className="team-avatar"
                                          />
                                        ) : (
                                          <img
                                            src={getFormattedImageLink(
                                              emp.imagepath,
                                            )}
                                            height="40"
                                            className="team-avatar"
                                          />
                                        )}
                                      </div>
                                    </Link>
                                  </div>
                                </Tooltip>
                              ))
                            ) : (
                              <div style={{ marginLeft: -24 }}>
                                <p
                                  className="small-dark-secondary"
                                  style={{ paddingTop: 14 }}
                                >
                                  No Employee Assigned
                                </p>
                              </div>
                            )}
                          </div>
                          {form.participant && form.participant.length > 0 ? (
                            GetNumberOfEmp(form.participant[0].fullcount) >
                            0 ? (
                              <div
                                className="additional-count"
                                style={{ marginTop: 3 }}
                                onClick={(e) =>
                                  this.props.HelperSliderFlag(
                                    "right",
                                    true,
                                    "360review",
                                    form,
                                    e,
                                  )
                                }
                              >
                                <span>
                                  <div className="total-count-small">
                                    +
                                    {GetNumberOfEmp(
                                      form.participant[0].fullcount,
                                    )}
                                  </div>
                                </span>
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </Grid>
                        {form.opendate && (
                          <div className={"floatleft margin-top-4"}>
                            <div className="input-label text-align-center">
                              Open date: {getFormattedDate(form.opendate)}
                            </div>
                          </div>
                        )}
                      </div>
                    </Grid>
                  </div>
                ))}
            </Grid> */}
            <Table>
              <TableHead style={{ background: "#edf5fd" }}>
                <TableRow>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">
                      Employee under Review
                    </p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">Status</p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">Form name</p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">Review period</p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">Participants</p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold">Release date</p>
                  </TableCell>
                  <TableCell>
                    <p className="small-dark-secondary t-bold"></p>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {forms &&
                  forms.map((form) => (
                    <TableRow
                      onClick={() => this.props.openForm(form)}
                      className="cursor-pointer"
                    >
                      <TableCell>
                        <div className="display-flex">
                          <span className="margin-right-8">
                            <ProfilePicture
                              src={getFormattedImageLink(form.imagepath)}
                              height="24"
                            />
                          </span>
                          <span className="small-dark-secondary t-bold">
                            {form.fullname}
                          </span>
                        </div>
                      </TableCell>
                      <TableCell>
                        <img
                          src={
                            form.statusid == 1
                              ? eyeball
                              : form.statusid == 4
                              ? sleepface
                              : form.statusid == 5
                              ? raisinghands
                              : checkall
                          }
                          height="24"
                          width="24"
                        ></img>
                      </TableCell>
                      <TableCell style={{ width: 200 }}>
                        <p className="small-dark-secondary">{form.formtitle}</p>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary">
                          {form.reviewperiodtypeid == 1
                            ? "Monthly"
                            : form.reviewperiodtypeid == 2
                            ? "Quarterly"
                            : form.reviewperiodtypeid == 3
                            ? "Semi-Annually"
                            : form.reviewperiodtypeid == 4
                            ? "Annually"
                            : " - "}
                        </p>
                      </TableCell>
                      <TableCell>
                        <Grid container>
                          <div
                            className="avtar-thumb-wrapper-small"
                            style={{ height: 32 }}
                          >
                            {form.participant && form.participant.length > 0 ? (
                              form.participant.map((emp) => (
                                <Tooltip
                                  key="key"
                                  title={emp.employeename || emp.fullname}
                                  placement="bottom"
                                  classes={{
                                    tooltip: classes.customWidth,
                                  }}
                                >
                                  <div
                                    className={
                                      GetNumberOfEmp(
                                        form.participant[0].fullcount,
                                      ) > 0
                                        ? "avtar-thumb-blur"
                                        : "avtar-thumb"
                                    }
                                    style={{
                                      height: 32,
                                      width: 32,
                                      marginLeft: -12,
                                    }}
                                  >
                                    <Link
                                      to={`./profile/${emp.employeeid}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <div
                                        className="avatar-wrapper-small"
                                        style={{ height: 32 }}
                                      >
                                        {emp.imagepath == null ? (
                                          <img
                                            src={DefaultProfileImage}
                                            height="32"
                                            className="team-avatar"
                                          />
                                        ) : (
                                          <img
                                            src={getFormattedImageLink(
                                              emp.imagepath,
                                            )}
                                            height="32"
                                            className="team-avatar"
                                          />
                                        )}
                                      </div>
                                    </Link>
                                  </div>
                                </Tooltip>
                              ))
                            ) : (
                              <div style={{ marginLeft: -24 }}>
                                <p
                                  className="small-dark-secondary"
                                  style={{ paddingTop: 6 }}
                                >
                                  No Employee Assigned
                                </p>
                              </div>
                            )}
                          </div>
                          {form.participant && form.participant.length > 0 ? (
                            GetNumberOfEmp(form.participant[0].fullcount) >
                            0 ? (
                              <div
                                className="additional-count"
                                style={{
                                  marginTop: 3,
                                  height: 32,
                                  width: 32,
                                  marginLeft: -29,
                                }}
                                onClick={(e) =>
                                  this.props.HelperSliderFlag(
                                    "right",
                                    true,
                                    "360review",
                                    form,
                                    e,
                                  )
                                }
                              >
                                <span>
                                  <div
                                    className="total-count-small"
                                    style={{ top: 4 }}
                                  >
                                    +
                                    {GetNumberOfEmp(
                                      form.participant[0].fullcount,
                                    )}
                                  </div>
                                </span>
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </Grid>
                      </TableCell>
                      <TableCell>
                        <p className="small-dark-secondary">
                          {getFormattedDate(form.opendate)}
                        </p>
                      </TableCell>
                      <TableCell>
                        {form.actions &&
                          ((statusid == 5 && form.actions.isreleased) ||
                            (statusid != 3 && form.actions.iscancle) ||
                            (statusid != 4 && form.actions.isonhold)) && (
                            <div
                              className="floatright cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  showform: form,
                                  moreDetails: true,
                                  moreDeatail_anchorEl: e.currentTarget,
                                });
                              }}
                            >
                              <img src={kebabIcon}></img>
                            </div>
                          )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </InfiniteScroll>
        </div>

        <Popover
          open={this.state.moreDetails}
          anchorEl={this.state.moreDeatail_anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() =>
            this.setState({
              showform: null,
              moreDetails: false,
              moreDeatail_anchorEl: null,
            })
          }
          className="margin-top-8"
        >
          <Paper className="rounded-rectangle-paper">
            <div>
              <List>
                {statusid == 5 &&
                  showform &&
                  showform.actions &&
                  showform.actions.isreleased && (
                    <ListItem
                      button
                      className="padding-top-4 padding-bottom-4 cursor-pointer"
                      onClick={(e) => this.takeAction(e, showform, 6)}
                    >
                      <ListItemIcon>
                        <img src={broadcastIcon}></img>
                      </ListItemIcon>
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Release</span>
                      </ListItemText>
                    </ListItem>
                  )}

                {statusid != 4 &&
                  showform &&
                  showform.actions &&
                  showform.actions.isonhold && (
                    <ListItem
                      button
                      className="padding-top-4 padding-bottom-4 cursor-pointer"
                      onClick={(e) => this.takeAction(e, showform, 5)}
                    >
                      <ListItemIcon>
                        <img src={timeIcon}></img>
                      </ListItemIcon>
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">
                          Put on hold
                        </span>
                      </ListItemText>
                    </ListItem>
                  )}
                {/* {statusid != 3 && (
                  <ListItem
                    button
                    className=" padding-top-4 padding-bottom-4 cursor-pointer"
                    onClick={(e) => this.takeAction(e, showform, 9)}
                  >
                    <ListItemIcon>
                      <img src={clock}></img>
                    </ListItemIcon>
                    <ListItemText style={{ padding: 0 }}>
                      <span className="small-dark-secondary">
                        Extend closing date
                      </span>
                    </ListItemText>
                  </ListItem>
                )} */}
                {statusid == 4 && (
                  <ListItem
                    button
                    className=" padding-top-4 padding-bottom-4 cursor-pointer"
                    onClick={(e) => this.takeAction(e, showform, 11)}
                  >
                    <ListItemIcon>
                      <img src={timeIcon}></img>
                    </ListItemIcon>
                    <ListItemText style={{ padding: 0 }}>
                      <span className="small-dark-secondary">
                        Remove from Hold
                      </span>
                    </ListItemText>
                  </ListItem>
                )}

                {statusid != 3 &&
                  showform &&
                  showform.actions &&
                  showform.actions.iscancle && (
                    <ListItem
                      button
                      className="padding-top-4 padding-bottom-4 cursor-pointer"
                      onClick={(e) => this.takeAction(e, showform, 4)}
                    >
                      <ListItemIcon>
                        <img src={deleteIcon}></img>
                      </ListItemIcon>
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">
                          Cancel form
                        </span>
                      </ListItemText>
                    </ListItem>
                  )}
              </List>
            </div>
          </Paper>
        </Popover>
      </Grid>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Card)));
